import { useTranslation } from "react-i18next";
import { BRAND_BRAIN_POLL_BASE_PATH, updateBrandBrain } from "@/features/brand-brain/api/brand-brain.api";
import { brandBrainKeys, tenantOnboardingKeys } from "@/lib/queries";
import { useAmberMutation } from "@/lib/use-amber-mutation";

/** The page shows every failure inline (with the rejected field), so there is no error toast. */
export function useUpdateBrandBrain() {
  const { t } = useTranslation();
  return useAmberMutation({
    mutationFn: updateBrandBrain,
    pollBasePath: BRAND_BRAIN_POLL_BASE_PATH,
    successMessage: t("brandBrain.edit.saved", "Brand Brain updated"),
    invalidateKeys: [brandBrainKeys.all, tenantOnboardingKeys.all],
    skipErrorToast: () => true,
  });
}
